import Indicador from "..";
import ACSEditFields from "./components/ACSEditFields";
import { ACSParamFields } from "./components/ACSParamFields";
import acsReport from "./reports";
import acsReportSummary from "./reports/summary";

export default class ACS extends Indicador {
    static get fullName() {
        return "Avaliação de Canas Secas e Doentes";
    }

    static get abbrev() {
        return "ACS";
    }

    static get legacyApontamentoMap() {
        return {
            dataHoraEES: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            trator: "trator",
            frente: "frente",

            turno: "turno",

            coletas: {
                type: Array,
                newField: "coletas",
                children: {
                    qtdCanasAvaliados: "avaliados",
                    canasSecasDoentes: "secasDoentes",
                    canasSecasDoentesPercentual: "secasDoentesPercentual",
                    descricao: "observacao",
                    foto: {
                        newField: "image.uid",
                        convert: this.convertLegacyImageUid,
                    },
                    confirmaRelatorio: "confirmaRelatorio",
                    "foto.georeferencia": "georeferencia",
                    georeferencia: "georeferencia",
                },
            },

            conformidadeAmostra: "conformidade",

            observacaoAmostra: "observacao",

            itensColeta: "images",
        };
    }

    static get legacyParamMap() {
        return {
            metaCanasSecasDoentesManual: "manual.meta",

            metaCanasSecasDoentesMecanizado: "mecanizado.meta",

            classificacaoCanasSecasDoentes: {
                type: Array,
                newField: "items",
                paramMap: {
                    classificacao: "classificacao",
                    valorMinimo: "intervaloMin",
                    valorMaximo: "intervaloMax",
                    sinalIntervaloMin: "sinalIntervaloMin",
                    sinalIntervaloMax: "sinalIntervaloMax",
                },
            },
        };
    }

    static paramFields(tipoIndicadorField = '') {
        return <ACSParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <ACSEditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return acsReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return acsReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        console.log('apontamento.coletas', apontamento.coletas)
        if (!apontamento.coletas
            || !params
            || apontamento.coletas.length === 0
            || (apontamento.coletas.filter(c => c.avaliados && c.secasDoentes).length === 0)
        ) {
            return 0;
        }

        const total = apontamento.coletas.length;
        let sumSecasDoentesPercentual = 0;

        for (const coleta of apontamento.coletas) {
            // 'avaliados' deve ser um número != 0.
            if (coleta.secasDoentes && f(coleta.avaliados)) {
                coleta.secasDoentesPercentual = (100 * f(coleta.secasDoentes)) / f(coleta.avaliados);
                sumSecasDoentesPercentual += coleta.secasDoentesPercentual;

                coleta.secasDoentesPercentual = f(coleta.secasDoentesPercentual).toFixed(2);
            } else {
                coleta.secasDoentesPercentual = "0.00";
            }
            coleta.acima = f(coleta.secasDoentesPercentual) > f(params.meta) ? 1 : 0
            coleta.abaixo = 0
        }

        return (sumSecasDoentesPercentual / total).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatusInverte(conformidade, meta, 110, 100, 90);
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 50, getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 25 },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },
            { title: "Talhão", field: "talhao.nome" },
            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },

            { title: "Canas", field: "totalCanas", width: 'auto' },
            { title: "Brocados", field: "totalBrocados", width: 'auto' },
            { title: "Entrenós", field: "totalEntrenos", width: 'auto' },

            {
                title: "% Infestação", field: "conformidade", width: 'auto', getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },

        ]
    }

    static getResultStr(apontamento) {
        let totalCanas = apontamento.coletas.reduce((total, c) => total += parseInt(c.avaliados), 0)
        let totalSecasDoentes = apontamento.coletas.reduce((total, c) => total += parseInt(c.secasDoentes), 0)

        return "Canas Avaliadas: " + totalCanas +
            " e Canas Secas/Doentes: " + totalSecasDoentes
    }
}
